import type { InputEvent } from '@br/protocol';
import type { Point } from './coords';
import { modifiersOf, type ModifierKeys } from './mouse';

export type InputWheel = Extract<InputEvent, { t: 'input.wheel' }>;

export interface WheelLike extends ModifierKeys {
  deltaX: number;
  deltaY: number;
  /** 0 = pixels, 1 = lines, 2 = pages */
  deltaMode: number;
}

const LINE_PX = 16;
const MAX_DELTA = 4000;

/** Normalises the three deltaMode units to CSS pixels, clamped to something sane. */
export function normalizeWheel(e: WheelLike, pageHeightPx: number): Point {
  const factor = e.deltaMode === 1 ? LINE_PX : e.deltaMode === 2 ? Math.max(1, pageHeightPx) : 1;
  const clamp = (v: number) => Math.max(-MAX_DELTA, Math.min(MAX_DELTA, Math.round(v * factor)));
  return { x: clamp(e.deltaX), y: clamp(e.deltaY) };
}

export function buildWheelEvent(
  tabId: string,
  pos: Point,
  e: WheelLike,
  pageHeightPx: number,
): InputWheel {
  const d = normalizeWheel(e, pageHeightPx);
  return {
    t: 'input.wheel',
    tabId,
    x: pos.x,
    y: pos.y,
    deltaX: d.x,
    deltaY: d.y,
    modifiers: modifiersOf(e),
  };
}
